import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/BasketPerson`;


function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
      if (value !== undefined && value !== null)
          stringparams = stringparams + key + "=" + value + "&";
          return stringparams;
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  
  return stringparams;
}

const ApiBasketPerson = {

  // getBasketPersonByUserId: (params) => {
  //   
  //   const url = `${baseServiceUrl}/getBasketPersonByUserId?id=` + params;
  //   
  //   return ServiceApi.get(url, { params });
  // },
  createBasketPerson: (params) => {
    
    const url = `${baseServiceUrl}/createBasketPerson`;
    
    return ServiceApi.post(url,  params );
  },
  updateBasketPerson: (params) => {
    
    const url = `${baseServiceUrl}/updateBasketPerson`;
    
    return ServiceApi.put(url, params );
  },
  deleteBasketPerson: (params) => {
    
    const url = `${baseServiceUrl}/deleteBasketPerson`+ paramsToStringList(params);
    
    return ServiceApi.delete(url, params);
  },
  getBasketPersonByUserId: (params) => {
    
    const url = `${baseServiceUrl}/getBasketPersonByUserId?id=` + params;
    
    return ServiceApi.get(url, { params });
  },
  putAddOrEditBasketPerson: (params) => {
    
    const url = `${baseServiceUrl}/putAddOrEditBasketPerson`;
    
    return ServiceApi.put(url, params );
  },
  cancleBasketItemPerson : (params) => {
    
    const url = `${baseServiceUrl}/CancelBasketItemPerson`;
    
    return ServiceApi.post(url, params );
  },
  getBasketCancelType : () =>{
    
    const url = `${baseServiceUrl}/GetBasketCancelType` ;
    
    return ServiceApi.get(url );
  }




  // /api/v{version}/BasketPerson/GetBasketCancelType
  // addOrEditBasketItemPersonBylist: (params) => {
  //   
  //   const url = `${baseServiceUrl}/addOrEditBasketItemPersonBylist`;
  //   
  //   return ServiceApi.post(url,  params );
  // },
  // getBasketPersonListByBasketItemId: (params) => {
  //   
  //   const url = `${baseServiceUrl}/getBasketPersonListByBasketItemId?id=` + params;
  //   
  //   return ServiceApi.get(url,  params );
  // },
  
};

export default ApiBasketPerson;


